import React, { Component } from 'react'
import c from 'classnames'
import { dispatch } from 'src/store'
import { useRequestDemoLightboxBehavior, hideForm } from 'src/actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Link from 'src/components/link'
import Page from 'src/components/page'
import Image from 'src/components/image'
import PillButton from 'src/components/pill-button'
import closeTechniqueBtn from 'src/assets/close-technique.svg'
import techniqueLeftArrow1 from 'src/assets/technique-left-arrow-1.svg'
import techniqueLeftArrow2 from 'src/assets/technique-left-arrow-2.svg'
import techniqueRightArrow from 'src/assets/technique-right-arrow.svg'
import config from 'src/config'

let fraudAssets = {}
config.fraudCategories.forEach(category => {
  category.fraudTechniques.forEach(technique => {
    fraudAssets[technique.id] = {
      gif: require(`src/assets/fraud/${technique.id}.gif`),
    }
  })
})

export class FraudTechniquePage extends Component {
  static propTypes = {
    className: PropTypes.string,
    pageContext: PropTypes.object.isRequired,
    windowWidth: PropTypes.number.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  componentDidMount = () => {
    dispatch(useRequestDemoLightboxBehavior())
    dispatch(hideForm())
  }

  get className() {
    const { className } = this.props
    return c('im-fraud-technique-page', className)
  }

  render() {
    const { className } = this
    const { technique, techniques, category, previousTechnique, nextTechnique } = this.props.pageContext
    const { windowWidth } = this.props
    const isDesktop = windowWidth > 1215

    return (
      <Page pageContentClassName={className} title={technique.pageTitle}>
        <div className="technique-top-nav">
          <Link to={`/protect-monitor/performance-fraud/${category.id}`} className="close-btn">
            <Image src={closeTechniqueBtn} alt="Close Technique Button" />
          </Link>
          {!isDesktop && previousTechnique && (
            <Link
              to={`/protect-monitor/performance-fraud/${previousTechnique.id}`}
              className="technique-left-arrow-1">
              <Image src={techniqueLeftArrow1} alt="Technique Left Arrow 1" />
            </Link>
          )}
        </div>
        {!isDesktop && (
          <section className="mobile-graphic">
            <img src={fraudAssets[technique.id].gif} alt={technique.label} />
          </section>
        )}
        <section className="hero-copy">
          <h4 className="category">{`${category.label} fraud`}</h4>
          <h1 className="technique as-h2">{technique.label}</h1>
          <p className="summary" dangerouslySetInnerHTML={{ __html: technique.summary }} />
        </section>
        <section className="steps-and-graphic">
          <div className="technique-bottom-nav">
            {isDesktop && previousTechnique && (
              <Link
                to={`/protect-monitor/performance-fraud/${previousTechnique.id}`}
                className="technique-left-arrow-2">
                <Image src={techniqueLeftArrow2} alt="Technique Left Arrow 2" />
              </Link>
            )}
            {isDesktop && nextTechnique && (
              <Link
                to={`/protect-monitor/performance-fraud/${nextTechnique.id}`}
                className="technique-right-arrow">
                <Image src={techniqueRightArrow} alt="Technique Right Arrow" />
              </Link>
            )}
          </div>
          <section className="steps">
            <h2>How they do it</h2>
            <ol>
              {technique.steps.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ol>
          </section>
          {isDesktop && (
            <section className="graphic">
              <Image cover={false} src={fraudAssets[technique.id].gif} alt={technique.label} />
            </section>
          )}
        </section>
        <section className="nav-dots">
          {techniques.map(tec => (
            <Link
              key={tec.id}
              to={`/protect-monitor/performance-fraud/${tec.id}`}
              className={c('nav-dot', tec.id === technique.id && 'selected')}
            />
          ))}
        </section>
        {nextTechnique && (
          <section className="next">
            <Link to={`/protect-monitor/performance-fraud/${nextTechnique.id}`}>
              <PillButton color="red">Next</PillButton>
            </Link>
          </section>
        )}
      </Page>
    )
  }
}

export default connect(state => ({
  windowWidth: state.windowWidth,
}))(FraudTechniquePage)
